import type { RadioToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useRadioTokens = (theme: Theme): RadioToken => {
  const { color, font, component } = theme;
  const base = {
    defaultColor: color.onSurface,
    activeColor: color.primary,
    disabledColor: color.onDisabled,
    errorColor: color.negative,
    labelColor: color.onSurfaceVariant,
    subLabelColor: color.onSurfaceVariant,
    fontFamily: font.base,
    requiredIndicatorColor: color.onSurfaceVariant,
  };

  return merge({}, base, component?.radio) as RadioToken;
};
